import React, { useEffect, useRef } from "react";
import { Link, useLocation } from "react-router-dom";
import { heroDishes, fullName } from "../data/dishes";
import { navLinks, business } from "../data/business";
import SocialLinks from "./SocialLinks";

// Circular navigation reveal. Native <dialog> provides the focus trap and
// Escape handling; the circle expands from the trigger corner.
export default function NavDialog({ open, onClose, returnFocusTo }) {
  const ref = useRef(null);
  const location = useLocation();

  useEffect(() => {
    const el = ref.current;
    if (!el) return;
    if (open && !el.open) {
      el.showModal();
      document.body.classList.add("ro-locked");
      const first = el.querySelector(".ro-nav__links a");
      if (first) first.focus();
    } else if (!open && el.open) {
      el.close();
    }
  }, [open]);

  useEffect(() => {
    const el = ref.current;
    if (!el) return undefined;
    const handleClose = () => {
      document.body.classList.remove("ro-locked");
      onClose();
      if (returnFocusTo && returnFocusTo.current) returnFocusTo.current.focus();
    };
    el.addEventListener("close", handleClose);
    return () => el.removeEventListener("close", handleClose);
  }, [onClose, returnFocusTo]);

  // Close when a route is chosen.
  useEffect(() => {
    if (ref.current && ref.current.open) ref.current.close();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location.pathname]);

  return (
    <dialog ref={ref} id="ro-navigation" className="ro-nav" aria-label="Main navigation">
      <div className="ro-nav__circle" aria-hidden="true" />
      <button type="button" className="ro-nav__close" aria-label="Close navigation" onClick={() => ref.current.close()}>
        <span aria-hidden="true">×</span>
      </button>
      <div className="ro-nav__content">
        <div className="ro-nav__foods">
          {heroDishes.map((d) => (
            <Link key={d.id} to={`/menu/${d.id}`} aria-label={fullName(d)} className="ro-nav__food">
              <img src={d.image} alt="" width="85" height="85" />
            </Link>
          ))}
        </div>
        <nav className="ro-nav__links" aria-label="Primary">
          {navLinks.map((l) => (
            <Link key={l.to} to={l.to} aria-current={location.pathname === l.to ? "page" : undefined}>
              {l.label}
            </Link>
          ))}
        </nav>
        <div className="ro-nav__social">
          <SocialLinks items={business.social} light />
        </div>
      </div>
    </dialog>
  );
}
